import { type PlanData } from "../../types/SubscriptionEmbed";
import { Config, httpGet } from "../../services/api";
import { convertKeysToCamelCase } from "../utils/convertKeysToCamelCase";

type SubscriptionPlanGroup = {
  id: string;
  created: string;
  currency: string;
  name: string;
  is_live: boolean;
  plans: PlanData[];
};

export const sdkGetSubscriptionPlanGroups = async ({
  currency,
  publicApiKey,
  limit = 10,
  offset = 0,
}: {
  currency?: string;
  publicApiKey: string;
  limit?: number;
  offset?: number;
}) => {
  const {
    data: planGroups,
    count,
    next,
    previous,
  } = await httpGet<{
    data: SubscriptionPlanGroup[];
    count: number;
    next: string | null;
    previous: string | null;
  }>(
    `${import.meta.env.VITE_API_BASE}/api/${
      Config.apiVersion
    }/subscriptions/plan-groups/?include_plans=true&${
      currency ? `currency=${currency}` : ""
    }&limit=${limit}&offset=${offset}`,
    true,
    undefined,
    {
      "x-public-key": publicApiKey,
    }
  );

  return {
    count,
    planGroups: planGroups.map((group) => ({
      id: group.id,
      created: group.created,
      currency: group.currency,
      name: group.name,
      plans: group.plans.map(convertKeysToCamelCase),
    })),
    hasNext: !!next,
    hasPrevious: !!previous,
  };
};
